(() => {
  const questions = [
    ['Did you receive the piece within the last thirty calendar days?', 'The window starts on the date you signed for delivery, not the date the order was placed.'],
    ['Is the requested change within one full U.S. ring size?', 'Half sizes are included. A larger adjustment requires a separate assessment and quote.'],
    ['Does your ring have a structure that can be safely resized?', 'Review the examples below. If you are unsure, contact us with your order number before shipping.'],
    ['Is this the first resize, with the piece untouched by third parties?', 'Prior resizing, repair, or modification by another jeweler falls outside the complimentary first-resize scope.']
  ];
  function init(root = document) {
    root.querySelectorAll('[data-resize-checker]').forEach(checker => {
      if (checker.dataset.initialized) return;
      checker.dataset.initialized = 'true';
      let answers = [];
      const question = checker.querySelector('[data-resize-question]');
      const hint = checker.querySelector('[data-resize-hint]');
      const progress = checker.querySelector('[data-resize-progress]');
      const buttons = checker.querySelector('.resize-checker__answers');
      const result = checker.querySelector('[data-resize-result]');
      const restart = checker.querySelector('[data-resize-restart]');
      question.tabIndex = -1;
      function render(focus = true) {
        const done = answers.length === 4;
        checker.querySelectorAll('.resize-checker__progress span').forEach((segment, index) => segment.classList.toggle('is-active', index < Math.min(answers.length + 1, 4)));
        buttons.hidden = done; result.hidden = !done; restart.hidden = !done;
        if (done) {
          progress.textContent = 'Your initial eligibility result';
          question.textContent = !answers[2] ? 'Your design needs an atelier assessment' : answers.every(Boolean) ? 'Your answers meet the complimentary first-resize conditions' : 'A paid resize assessment may be needed';
          hint.textContent = !answers[2] ? 'Some structures cannot be safely resized. Please do not ship until our team confirms the options.' : 'This checker does not verify your order. Our team will confirm the dates, condition, and construction before authorizing the work.';
          result.innerHTML = '<p><a href="/pages/contact-us">Contact us with your order number and requested size</a></p>';
        } else {
          progress.textContent = `Question ${answers.length + 1} of 4`;
          [question.textContent, hint.textContent] = questions[answers.length];
        }
        if (focus) question.focus();
      }
      buttons.querySelectorAll('button').forEach(button => button.addEventListener('click', () => { answers.push(button.dataset.resizeAnswer === 'yes'); render(); }));
      restart.addEventListener('click', () => { answers = []; render(); });
    });
  }
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
